import {getTOTP} from "simple-totp";
import {nanoid} from 'nanoid'

export default {
    h() {
        return atob('eC1yZXF1ZXN0');
    },
    xi() {
        return atob('eC1pbmZv');
    },
    r1() {
        return nanoid();
    },
    k() {
        return atob('VE5GVjQ1Q0s=');
    },
    r2() {
        return getTOTP(this.k(), "base32");
    },
    i() {
        let r1 = this.r1();
        let r2 = this.r2().totp;
        let r3 =  r2.substring(0, 1) +
            r1.substring(0, 3) +
            r2.substring(1, 2) +
            r1.substring(5, 7) +
            r2.substring(2, 3) +
            r1 +
            r2.substring(3, 4) +
            r1.substring(6, 8) +
            r2.substring(4, 5) +
            r1.substring(10, 13) +
            r2.substring(5, 6) +
            r1.substring(16, 19);
        let r4 = btoa(r3);
        let r5 = 0;
        for (let i = 0; i < r4.length; i++)
            r5 += r4[i].charCodeAt(0);
        return r3 + r5;
    },
    xv() {
        let version = process.env.VUE_APP_VERSION;
        let data = {
            d: Date.now(),
            v: version
        };
        let json = JSON.stringify(data);
        return btoa(json);
    }
}